import { API_ROOT } from 'constants'
import { ACTION_UPDATE, ACTION_EXTEND, DISPLAY_MODE_STANDARD } from './interface'
import { getSiteFiles, editSite } from 'services/v2/pro'
import { zipMultipleFiles } from 'utils/general'
import api from 'utils/api'
import { DISPLAY_MODE_EMAIL_GATE } from 'components/CreateSiteModal/CreateSiteForm/components/DisplayModeSelect/DisplayModeSelect'

/**
 * Query
 */

export const getSite = async (action, subdomain) => {
  switch (action) {
    case ACTION_UPDATE: {
      try {
        const { data } = await getSiteFiles({ domain: subdomain })
        return data
      } catch (error) {
        throw new Error(error)
      }
    }
    case ACTION_EXTEND: {
      break
    }
    default: {
      setFiles([])
    }
  }
}

/**
 * Mutation
 */

/** Use to edit domain and site settings (V2)
 *  @todo: handle upload
 */

export const updateSite = async (domain, values) => {
  try {
    const { data } = await editSite(domain, values)

    return data
  } catch (error) {
    throw error
  }
}

/** Use to create or update site when new file is uploaded (V1)
 * @todo: test with big files
 */

export const createOrUpdateSite = async (
  { domainValues, uploadValues, toggleValues },
  action,
  executeRecaptcha,
  uploadProgress
) => {
  const endpoint = `${API_ROOT}/pro/${action.toLowerCase()}`
  const formData = new FormData()

  const { subdomain, domainSuffix } = domainValues

  const { selectedFile, addedFiles, indexFile } = uploadValues

  const {
    disableIndexing,
    password,
    displayMode,
    gatedMode,
    passwordProtected,
    disableExportPdf,
    siteConfiguration,
    errorPath
  } = toggleValues

  formData.append('subdomain', subdomain.toLowerCase())
  formData.append('domainSuffix', domainSuffix)
  formData.append('disableIndexing', disableIndexing)
  formData.append('passwordProtected', passwordProtected)

  if (indexFile) {
    formData.append('indexFile', indexFile)
  }

  formData.append('enableEmailGate', gatedMode === DISPLAY_MODE_EMAIL_GATE ? 'true' : 'false')

  if (passwordProtected && password) formData.append('password', password)

  if (disableExportPdf) formData.append('disableExportPdf', disableExportPdf)

  if (displayMode !== DISPLAY_MODE_STANDARD) formData.append('displayMode', displayMode)

  if (siteConfiguration && errorPath) formData.append('siteConfiguration', JSON.stringify({ errorPath }))

  if (selectedFile?.isTemplate) {
    formData.append('useTemplate', selectedFile?.path)
  } else {
    if (addedFiles.length > 0) {
      formData.append('file', await zipMultipleFiles([...addedFiles, selectedFile]))
    } else {
      formData.append('file', selectedFile)
    }
  }

  try {
    const recaptchaValue = await executeRecaptcha('pro')
    const headers = {
      'x-recaptcha': recaptchaValue
    }
    const { data } = await api.post(endpoint, formData, headers, (event) => uploadProgress(event, selectedFile))

    return data
  } catch (error) {
    throw error
  }
}
